// extracted by mini-css-extract-plugin
export default {"table_container":"styles_table_container__+wnU6","loader_container":"styles_loader_container__4bt7p","customTable":"styles_customTable__SkQgb","no_data":"styles_no_data__NtCOj"};